import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import { IDataPackage, IDataPackageFileApi } from '@vivli/shared/features/data-package/infrastructure/interface';

export const useDataPackageFileApi = (useSecureStorage = true): IDataPackageFileApi => {
    const { handleGet, handlePost, handlePut } = useAuthRestApi();
    const downloadFileUri = (dataPackageId: string, fileName: string, recordHistory: boolean): Observable<string> => {
        return handlePost<string>(`/files/${dataPackageId}/${recordHistory}/${useSecureStorage}`, fileName);
    };

    const deleteFile = (dataPackageId: string, fileName: string): Observable<IDataPackage> => {
        return handlePut<IDataPackage>(`/files/${dataPackageId}/deleteFile/${useSecureStorage}`, fileName);
    };

    const downloadDataRequestStudyFiles = (dataRequestId: string): Observable<string> => {
        return handleGet<string>(`/files/${dataRequestId}/downloadzipfile`);
    };

    const getBadExtensionFileList = (dataRequestId: string, zipFilePath: string, forResultsRequest: boolean): Observable<string[]> => {
        return handleGet<string[]>(`/files/${dataRequestId}/${zipFilePath}/${forResultsRequest}`);
    };

    const getBadExtensionFileListForDataPackage = (dataRequestId: string, forResultsRequest: boolean): Observable<string[]> => {
        return handleGet<string[]>(`/files/${dataRequestId}/${forResultsRequest}`);
    };

    return {
        downloadFileUri,
        deleteFile,
        downloadDataRequestStudyFiles,
        getBadExtensionFileList,
        getBadExtensionFileListForDataPackage
    };
};
